import { Component, Inject, OnDestroy, OnInit, Renderer2, RendererStyleFlags2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ProfileNavStateService } from '../shared/profile-nav-state.service';
import { HeaderStateService } from '../shared/header-state.service';
import { ProfileNavService } from '../shared/profile-nav.service';
import { CookieService } from 'ngx-cookie-service';

interface ProfileSection {
  id: string;
  label: string;
  value?: string;
  action: string;
}

// Legacy shell wrappers (defined in global/brand stylesheets) that force fixed heights we need to flatten.
const LEGACY_WRAPPER_SELECTOR = '.h-100, .mt-76, .mainWidth, .dam-maxheight, .app-container';

// AppComponent adds one of these to document.body asynchronously (after brand/config resolves),
// so they must be watched and stripped continuously, not just once on init.
const BACKGROUND_IMAGE_CLASSES = [
  'backgroundImage', 'backgroundImage-m', 'backgroundImage-r4b', 'backgroundImage-xfi',
  'backgroundImage-sportnet', 'backgroundImage-discovery', 'backgroundImage-f'
];

@Component({
    selector: 'app-profile-overview',
    templateUrl: './profile-overview.component.html',
    styleUrls: ['./profile-overview.component.scss'],
    standalone: false
})
export class ProfileOverviewComponent implements OnInit, OnDestroy {
  selectedSectionId: string | null = null;
  detailInputValue = '';
  public userProfileDetails: any;  
  private originalBodyClassName = '';
  private legacyWrapperElements: HTMLElement[] = [];
  private bodyClassObserver?: MutationObserver;
  onSubmitFlow: (payload: object) => void;
  selectedForm: string ;

  sections: ProfileSection[] = [];

  constructor(
    public readonly profileNavState: ProfileNavStateService,
    private readonly headerStateService: HeaderStateService,
    private readonly renderer: Renderer2,
    @Inject(DOCUMENT) private readonly document: Document,
      private readonly profileNavService: ProfileNavService,
      private readonly cookieService: CookieService
  ) { }

  // Breaks this screen out of the shared narrow modal card so it renders as a full page,
  // and strips any brand background-image class so no photo shows behind this page.
  ngOnInit(): void {
    
    if(this.selectedForm === 'changeUsername' || this.selectedForm === 'confrimChangeUsername'){
      this.selectedSectionId = 'username';
    }
    
    //this.cookieService.set('userProfileDetails', this.userProfileDetails, undefined, undefined, null, true, 'None');

    this.sections = [
    { id: 'username', label: 'Username', value: this.userProfileDetails?.userID ?? '', action: 'Change username' },
    { id: 'password', label: 'Password', value: '••••', action: 'Change password' },
    { id: 'recovery-number', label: 'Recovery number', action: 'Change recovery number' },
    { id: 'mfa', label: 'Multi-factor authentication', action: 'Manage multi-factor authentication' },
    { id: 'passkeys', label: 'Passkeys', action: 'Manage passkeys' }
    ];

    //this.headerStateService.setHeaderState({ class: 'profile-overview-full-page' });
    //this.originalBodyClassName = this.document.body.className;
    //this.renderer.addClass(this.document.body, 'profile-overview-active');
    //this.stripBackgroundImageClasses();

    // AppComponent re-applies the background-image class asynchronously once brand config resolves;
    // keep stripping it for as long as this screen is active.
    //this.bodyClassObserver = new MutationObserver(() => this.stripBackgroundImageClasses());
    //this.bodyClassObserver.observe(this.document.body, { attributes: true, attributeFilter: ['class'] });

    //this.flattenLegacyWrappers();

    this.profileNavService.navigation$.subscribe(flow => {


    switch (flow) {


      case 'username':

        this.onSubmitFlow?.({ flow: 'username' });

        break;


      case 'password':

        this.onSubmitFlow?.({ flow: 'password' });

        break;


      case 'recovery-number':

        this.onSubmitFlow?.({ flow: 'mobile' });

        break;


      case 'mfa':

        this.onSubmitFlow?.({ flow: 'update_mfa' });

        break;


      case 'passkeys':

        this.onSubmitFlow?.({ flow: 'passkey_overview' });

        break;


      case 'overview':

        this.onSubmitFlow?.({ flow: 'user_cancel' });

        break;

    }


    });
 
  }

  ngOnDestroy(): void {
    //this.headerStateService.setHeaderState({});
    //this.bodyClassObserver?.disconnect();
    //this.document.body.className = this.originalBodyClassName;
    //this.restoreLegacyWrappers();
  }

  private stripBackgroundImageClasses(): void {
    BACKGROUND_IMAGE_CLASSES.forEach(className => {
      if (this.document.body.classList.contains(className)) {
        this.renderer.removeClass(this.document.body, className);
      }
    });
  }

  // The brand stylesheets set fixed heights (h-100/mt-76/mainWidth/etc.) on ancestor elements that
  // sit outside this component's own DOM subtree, and load as a separate bundle after ours, so CSS
  // overrides can lose the cascade. Forcing inline !important styles guarantees they always win.
  private flattenLegacyWrappers(): void {
    this.legacyWrapperElements = Array.from(
      this.document.querySelectorAll<HTMLElement>(LEGACY_WRAPPER_SELECTOR)
    );
    this.legacyWrapperElements.forEach(element => {
      this.renderer.setStyle(element, 'height', 'auto', RendererStyleFlags2.Important);
      this.renderer.setStyle(element, 'min-height', '0', RendererStyleFlags2.Important);
      this.renderer.setStyle(element, 'max-height', 'none', RendererStyleFlags2.Important);
      this.renderer.setStyle(element, 'margin-top', '0', RendererStyleFlags2.Important);
      this.renderer.setStyle(element, 'overflow', 'visible', RendererStyleFlags2.Important);
    });
  }

  private restoreLegacyWrappers(): void {
    this.legacyWrapperElements.forEach(element => {
      this.renderer.removeStyle(element, 'height');
      this.renderer.removeStyle(element, 'min-height');
      this.renderer.removeStyle(element, 'max-height');
      this.renderer.removeStyle(element, 'margin-top');
      this.renderer.removeStyle(element, 'overflow');
    });
    this.legacyWrapperElements = [];
  }

  get selectedSection(): ProfileSection | undefined {
    return this.sections.find(section => section.id === this.selectedSectionId);
  }

  // selectSection(sectionId: string): void {
  //   //this.selectedSectionId = sectionId;
  //   this.detailInputValue = '';
  //   this.profileNavState.close();

  //   this.onSubmitFlow({
  //     flow: 'username',
  //   });
  // }

  // showOverview(): void {
  //   this.selectedSectionId = null;
  //   this.profileNavState.close();
  // }

  // onChangeUsernameSubmit(payload: any): void {

  //   console.log('Change Username Submit received', payload);

  //   if (this.onSubmitFlow) {

  //     this.onSubmitFlow(payload);

  //   }
  // }

  // onConfirmChangeUsernameSubmit(payload: any): void {

  //   console.log('Confirm Change Username Submit received', payload);

  //   if (this.onSubmitFlow) {

  //     this.onSubmitFlow(payload);

  //   }
  // }

  changeUsername() {

  this.profileNavService.navigate('username');

}


changePassword() {

  this.profileNavService.navigate('password');

}


changeRecoveryNumber() {

  this.profileNavService.navigate('recovery-number');

}


changeMfa() {

  this.profileNavService.navigate('mfa');

}


changePasskeys() {

  this.profileNavService.navigate('passkeys');

}
 
}
